// Native Share Functionality
document.addEventListener('DOMContentLoaded', function() {
  const shareIcon = document.getElementById('share-icon-click');
  
  if (shareIcon) {
    // Click event
    shareIcon.addEventListener('click', handleShareClick);
    
    // Keyboard support
    shareIcon.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleShareClick();
      }
    });
  }
  
  function handleShareClick() {
    const shareUrl = shareIcon.getAttribute('data-share-url');
    const productTitle = shareIcon.getAttribute('data-product-title');
    
    // Check if native sharing is supported
    if (navigator.share) {
      navigator.share({
        title: productTitle,
        text: productTitle + ' - Check out this amazing product!',
        url: shareUrl
      }).then(() => {
        console.log('Content shared successfully');
      }).catch((error) => {
        console.log('Error sharing:', error);
        // Fallback: copy link to clipboard
        copyToClipboard(shareUrl);
      });
    } else {
      // Fallback: copy link to clipboard
      copyToClipboard(shareUrl);
    }
  }
  
  // Copy to clipboard function
  function copyToClipboard(text) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(function() {
        showToast('Link copied to clipboard!');
      }).catch(function(err) {
        fallbackCopyToClipboard(text);
      });
    } else {
      fallbackCopyToClipboard(text);
    }
  }
  
  // Fallback copy method for older browsers
  function fallbackCopyToClipboard(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand('copy');
      showToast('Link copied to clipboard!');
    } catch (err) {
      showToast('Could not copy link');
    }
    
    document.body.removeChild(textArea);
  }
  
  // Toast notification
  function showToast(message) {
    const toast = document.createElement('div');
    toast.textContent = message;
    toast.style.cssText = `
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: #333;
      color: white;
      padding: 12px 24px;
      border-radius: 6px;
      z-index: 10000;
      font-size: 14px;
      animation: slideUp 0.3s ease;
    `;
    
    document.body.appendChild(toast);
    
    setTimeout(() => {
      if (document.body.contains(toast)) {
        document.body.removeChild(toast);
      }
    }, 3000);
  }
  
  // Add CSS for toast animation
  if (!document.getElementById('native-share-styles')) {
    const style = document.createElement('style');
    style.id = 'native-share-styles';
    style.textContent = `
      @keyframes slideUp {
        from {
          opacity: 0;
          transform: translateX(-50%) translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateX(-50%) translateY(0);
        }
      }
    `;
    document.head.appendChild(style);
  }
});